import "./App.css";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import config from "./coreFIles/config";
import Login from "./component/login";
import ForgetPassword from "./component/forgetPassword";
import Changepassword from "./component/changepassword";
import UserDetails from "./component/User/UserDetails";
import Profile from "./component/Profile";
import ContactUs from "./component/Contactus/contactus";

import UserList from "./component/User/userList";

import AuthWrapper from "./utilities.js/authWrapper"

import PrivacyPolicy from "./component/cms/privacyPolicy";
import TermsCondition from "./component/cms/termsCondition";
import ViewUsers from "./component/User/viewUsers";
import EmailInsights from "./component/EmailInsights"


// ======================================================================================

import KycList from "./component/kyc/kycList";
import ViewKycUser from "./component/kyc/viewKycUser";
import TokenPurchaseHistory from "./component/purchaseHistory/tokenPurchaseHistory";
import TokenRisks from "./component/cms/tokenRisks";
import GoverningLaw from "./component/cms/governingLaw";
import AmlKycPolicy from "./component/cms/amlKycPolicy";
import FaqList from "./component/faq//faq";
import VestingSchedule from "./component/cms/vestingSchedule";
import EarlyAllocationRequest from "./component/EarlyAllocationRequest"
import SeedRound from "./component/SeedRound"
function App() {
  return (
    <BrowserRouter>
      <AuthWrapper>
        <div>
          <Routes>
            <Route path={`${config.baseUrl}`} element={<Login />} />
            <Route path={`${config.baseUrl}forget-password`} element={<ForgetPassword />} />
            <Route path={`${config.baseUrl}changepassword`} element={<Changepassword />} />
            <Route path={`${config.baseUrl}userdetail/:id`} element={<UserDetails />} />
            <Route path={`${config.baseUrl}profile`} element={<Profile />} />
            <Route path={`${config.baseUrl}contact-us`} element={<ContactUs />} />
            <Route path={`${config.baseUrl}email-insights`} element={<EmailInsights />} />
            <Route path={`${config.baseUrl}early-allocation-requests`} element={<EarlyAllocationRequest />} />
            <Route path={`${config.baseUrl}seed-round`} element={<SeedRound />} />

            <Route path={`${config.baseUrl}userList`} element={<UserList />} />

            <Route path={`${config.baseUrl}privacyPolicy`} element={<PrivacyPolicy />} />
            <Route path={`${config.baseUrl}termsCondition`} element={<TermsCondition />} />

            <Route path={`${config.baseUrl}viewUsers/:id`} element={<ViewUsers />} />
            <Route path={`${config.baseUrl}kycList`} element={<KycList />} />
            <Route path={`${config.baseUrl}viewKycUser/:id`} element={<ViewKycUser />} />

            <Route path={`${config.baseUrl}tokenPurchaseHistory`} element={<TokenPurchaseHistory />} />
            <Route path={`${config.baseUrl}tokenRisks`} element={<TokenRisks />} />
            <Route path={`${config.baseUrl}governingLaw`} element={<GoverningLaw />} />
            <Route path={`${config.baseUrl}amlKycPolicy`} element={<AmlKycPolicy />} />
            <Route path={`${config.baseUrl}faqList`} element={<FaqList />} />
            <Route path={`${config.baseUrl}vestingSchedule`} element={<VestingSchedule />} />

          </Routes>
        </div>
      </AuthWrapper>
    </BrowserRouter>
  );
}

export default App;
